import { MagicBox } from "@brg/ui"
import styled, { css } from "styled-components"

interface AdaptiveTitleContainerProps {
    usedBreakPoint?: number
    useWrap?: boolean
    fontSize?: number
    columnGap?: number

}

export const AdaptiveTitleContainer = styled(MagicBox)<AdaptiveTitleContainerProps>`
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: ${p => p.fontSize !== undefined ? p.fontSize : 60}px;
    column-gap: ${p => p.columnGap !== undefined ? p.columnGap : 0}px;
    line-height: 64px;
    color: ${p => p.theme.app.text};
    &:hover {
        color: ${p => p.theme.app.text};
    }
    ${p => p.usedBreakPoint !== undefined 
        ? css`
            width: ${p.usedBreakPoint}px;
        `
        : ''
    }
    ${p => p.useWrap ? 'flex-wrap: wrap;' : ''}
    span {
        color: inherit;
    }
`

export const LettersString = styled(MagicBox)<{letterSpacing?: number, w?: string}>`
    width: ${({ w }) => w || '100%'};
    letter-spacing: ${p => p.letterSpacing  ? p.letterSpacing + 'em' : 'normal'};
`

export const ComplexString = styled(MagicBox)<{letterSpacing?: number}>`
    letter-spacing: 0.05em;
    // overflow-wrap: anywhere;
`import { MagicBox } from "@brg/ui"
import styled, { css } from "styled-components"

interface AdaptiveTitleContainerProps {
    usedBreakPoint?: number
    useWrap?: boolean
    fontSize?: number
    columnGap?: number

}

export const AdaptiveTitleContainer = styled(MagicBox)<AdaptiveTitleContainerProps>`
    text-transform: uppercase;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 600;
    font-size: ${p => p.fontSize !== undefined ? p.fontSize : 60}px;
    column-gap: ${p => p.columnGap !== undefined ? p.columnGap : 0}px;
    line-height: 64px;
    color: ${p => p.theme.app.text};
    &:hover {
        color: ${p => p.theme.app.text};
    }
    ${p => p.usedBreakPoint !== undefined 
        ? css`
            width: ${p.usedBreakPoint}px;
        `
        : ''
    }
    ${p => p.useWrap ? 'flex-wrap: wrap;' : ''}
    span {
        color: inherit;
    }
`

export const LettersString = styled(MagicBox)<{letterSpacing?: number, w?: string}>`
    width: ${({ w }) => w || '100%'};
    letter-spacing: ${p => p.letterSpacing  ? p.letterSpacing + 'em' : 'normal'};
`

export const ComplexString = styled(MagicBox)<{letterSpacing?: number}>`
    letter-spacing: 0.05em;
    // overflow-wrap: anywhere;
`